var render = function render(_c,_vm){return _c('svg',{class:[_vm.data.class, _vm.data.staticClass, 'stella-icon'],style:(_vm.data.staticStyle),attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }